import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ThemeType } from "./theme.slice.types";

interface ThemeState {
    type: ThemeType;
}

export const getTheme = (): ThemeType => {
    const theme = window?.localStorage?.getItem("theme");
    if (theme === ThemeType.LIGHT || theme === ThemeType.DARK) {
        return theme;
    }
    return ThemeType.DARK;
};

const initialState: ThemeState = {
    type: getTheme(),
};

export const themeSlice = createSlice({
    name: "theme",
    initialState,
    reducers: {
        set: (state, action: PayloadAction<ThemeType>) => {
            state.type = action.payload;
        },
        toggleTheme: (state) => {
            const newTheme =
                state.type === ThemeType.DARK
                    ? ThemeType.LIGHT
                    : ThemeType.DARK;

            localStorage.setItem("theme", newTheme);

            state.type = newTheme;
        },
    },
});

export const { set, toggleTheme } = themeSlice.actions;

export default themeSlice.reducer;
